class UrgencyTimer extends HTMLElement {
constructor() {
    super();
    this.timerContainer = null;
    this.dateDisplay = null;
    this.interval = null;
}

connectedCallback() {
    this.timerContainer = this.querySelector('#urgency_timer');
    this.dateDisplay = this.querySelector('#dynamic_current_date');

    const now = new Date();
    const formattedNow = this.formatDate(now);

    if (this.dateDisplay) {
    this.dateDisplay.textContent = formattedNow;
    }

    this.init();
}

init() {
    this.setNextResetTime();
    this.startTimer();
}

setNextResetTime() {
    const now = new Date();
    const storedReset = localStorage.getItem('urgency_timer_reset');
    let resetTime;

    if (storedReset && parseInt(storedReset) > now.getTime()) {
    resetTime = new Date(parseInt(storedReset));
    } else {
    resetTime = new Date();
    resetTime.setHours(24, 0, 0, 0); // Midnight next local day
    localStorage.setItem('urgency_timer_reset', resetTime.getTime());
    }

    this.targetTime = resetTime.getTime();
}

startTimer() {
    this.updateTimer();

    this.interval = setInterval(() => {
    const currentTime = new Date().getTime();
    const distance = this.targetTime - currentTime;

    if (distance <= 0) {
        clearInterval(this.interval);
        localStorage.removeItem('urgency_timer_reset');

        const newDate = new Date();
        newDate.setHours(24, 0, 0, 0);

        if (this.dateDisplay) {
        this.dateDisplay.textContent = this.formatDate(new Date());
        }

        this.setNextResetTime();
        this.startTimer();
    } else {
        this.updateTimer();
    }
    }, 1000);
}

updateTimer() {
    const now = new Date().getTime();
    const distance = this.targetTime - now;

    const hours = Math.floor((distance % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60));
    const minutes = Math.floor((distance % (1000 * 60 * 60)) / (1000 * 60));
    const seconds = Math.floor((distance % (1000 * 60)) / 1000);

    const displayHours = String(hours).padStart(2, '0');
    const displayMinutes = String(minutes).padStart(2, '0');
    const displaySeconds = String(seconds).padStart(2, '0');

    if (this.timerContainer) {
    this.timerContainer.innerHTML = `
        <div class="time-block">
        <span class="time-value">${displayHours}</span>
        <span class="time-unit">HRS</span>
        </div>
        <div class="time-block">
        <span class="time-value">${displayMinutes}</span>
        <span class="time-unit">MIN</span>
        </div>
        <div class="time-block">
        <span class="time-value">${displaySeconds}</span>
        <span class="time-unit">SEC</span>
        </div>
    `;
    }
}

// Format date as "Jul. 10, 2025"
formatDate(date) {
    const months = ["Jan.", "Feb.", "Mar.", "Apr.", "May", "Jun.", "Jul.", "Aug.", "Sep.", "Oct.", "Nov.", "Dec."];
    const month = months[date.getMonth()];
    const day = date.getDate();
    const year = date.getFullYear();
    return `${month} ${day}, ${year}`;
}
}

customElements.define('custom-deliver-order', UrgencyTimer);



// Collapsible Tabs

class CollapsibleTabItem extends HTMLElement {
  constructor() {
    super();
    this.handleClick = this.handleClick.bind(this);
  }

  connectedCallback() {
    this.header = this.querySelector(".tab-header");
    this.panel = this.querySelector("[data-role='tab-panel']");

    // REMOVE THE HIDDEN ATTRIBUTE → Critical fix
    this.panel.removeAttribute("hidden");

    // Make header accessible
    this.header.setAttribute("role", "button");
    this.header.setAttribute("aria-expanded", "false");

    // Start collapsed
    this.panel.style.maxHeight = "0px";

    this.header.addEventListener("click", this.handleClick);
  }

  handleClick() {
    const isOpen = this.header.getAttribute("aria-expanded") === "true";

    if (isOpen) {
      this.close();
    } else {
      CollapsibleTabItem.closeOthers(this);
      this.open();
    }
  }

  open() {
    this.header.setAttribute("aria-expanded", "true");

    // STEP 1: set max-height to 0 first (ensure starting point)
    this.panel.style.maxHeight = "0px";

    // STEP 2: wait one animation frame
    requestAnimationFrame(() => {

      // STEP 3: wait ONE MORE frame to ensure stable state
      requestAnimationFrame(() => {
        const fullHeight = this.panel.scrollHeight;
        this.panel.style.maxHeight = fullHeight + "px";
      });

    });

    this.toggleIcons(true);
  }

  close() {
    this.header.setAttribute("aria-expanded", "false");

    // Collapse
    this.panel.style.maxHeight = "0px";

    // Toggle plus/minus icons
    this.toggleIcons(false);
  }

  toggleIcons(open) {
    const plus = this.header.querySelector(".plus");
    const minus = this.header.querySelector(".minus");

    if (plus && minus) {
      plus.style.display = open ? "none" : "block";
      minus.style.display = open ? "block" : "none";
    }
  }

  static closeOthers(current) {
    document.querySelectorAll("collapsible-tab-item").forEach(item => {
      if (item !== current) item.close();
    });
  }
}

customElements.define("collapsible-tab-item", CollapsibleTabItem);


